import React, { Component } from "react";
import { If } from "react-extras";
import { Button, Col, Grid, Row, Tab, Tabs, OverlayTrigger, Tooltip } from "react-bootstrap";
import get from "lodash/get";
import HighlightBox from "../../lib/highlight-box";
import { formatAudienceSize } from "../../../lib/audience_size";
import ExpandableText from "../../lib/expandable_text/expandable_text";
import PromotionsShowDetailsEpisodeList from "./promotions_show_details_episode_list";
import ExternalLink from "../../lib/external_link";
import LoadingImage from "../../lib/image";
import Spinner from "../../lib/spinner";
import PageWrapper from "../../lib/page-wrapper";
import "./promotions_show_page.scss";

import BrowseRow from "../browse_promotion/browse_row";
import { itunesCategories } from "../../../data/itunes_categories";

class PromotionsDetails extends Component {
  categoryList = show => {
    let categoryUUIDs = get(show, "categoryUUIDs", []);
    return categoryUUIDs
      .map(categoryUUID =>
        get(
          itunesCategories.find(({ uuid }) => categoryUUID === uuid),
          "name"
        )
      )
      .join(", ");
  };
  render() {
    const show = this.props.show;

    return (
      <PageWrapper
        backText="Browse"
        noDivider={true}
        backLink="/promotions/browse"
        className="promotions-show-page">
        <Spinner isLoading={this.props.isLoading} />
        <If condition={!this.props.isLoading && !!show}>
          <Grid fluid>
            <Row>
              <Col xs={12} md={3}>
                <LoadingImage
                  className="promotions-show-page__image"
                  imageURL={get(show, "imageURL")}
                />
              </Col>
              <Col xs={12} md={9}>
                <Row>
                  <Col xs={12}>
                    <h1 className="promotions-show-page__title">{get(show, "title")}</h1>
                    <div className="promotions-show-page__owner-name">{get(show, "ownerName")}</div>
                  </Col>
                </Row>
                <Row className="promotions-show-page__highlight-box-wrapper">
                  <Col xs={12} md={6}>
                    <HighlightBox
                      title="Weekly Audience"
                      value={formatAudienceSize(get(show, "bucketedAudienceSize"))}
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <HighlightBox title="Episodes" value={get(show, "episodes", []).length} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className="promotions-show-page__cross-promote-button-column">
                    <If condition={this.props.shouldDisableButton}>
                      <OverlayTrigger
                        defaultShow
                        overlay={
                          <Tooltip id="disabled-button-tip">
                            <strong>
                              You need to opt into the promotions marketplace and have at least one
                              podcast to participate in cross-promotion.
                            </strong>
                          </Tooltip>
                        }
                        show={null}
                        placement="bottom">
                        <div className="promotions-show-page__cross-promote-button-tipper" />
                      </OverlayTrigger>
                    </If>
                    <div className="promotions-show-page__cross-promote-button-wrapper">
                      <Button
                        className="btn-primary promotions-show-page__cross-promote-button"
                        disabled={this.props.shouldDisableButton}
                        onClick={this.props.handleClick}>
                        Propose a Cross Promotion
                      </Button>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Tabs unmountOnExit mountOnEnter id={"promotions-show-page__tabs"}>
                      <Tab title={"About"} eventKey="about">
                        <ExpandableText dangerousText={get(show, "description", "")} />
                        <div className="promotions-show-details-list-row__info">
                          <If condition={Boolean(get(show, "link"))}>
                            <div className="promotions-show-details-list-row__info-item">
                              <ExternalLink href={get(show, "link")}>Podcast Website</ExternalLink>
                            </div>
                          </If>
                          <div className="promotions-show-details-list-row__info-item">
                            {this.categoryList(show)}
                          </div>
                        </div>
                      </Tab>
                      <Tab title={"Episodes"} eventKey="episodes">
                        <If condition={Boolean(get(show, "episodes.length", 0) !== 0)}>
                          <PromotionsShowDetailsEpisodeList episodes={get(show, "episodes", [])} />
                        </If>
                        <If condition={get(show, "episodes.length", 0) === 0} show={show}>
                          <div className="promotions-show-details__no-episodes-text">
                            No episodes yet.
                          </div>
                        </If>
                      </Tab>
                    </Tabs>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <div className="promotion-show-details-page__similar-shows">
                      <BrowseRow
                        title={"Similar Podcasts"}
                        shows={get(this.props.categoryShows, get(show, "uuid"), [])}
                        count={4}
                        ignoreUUIDs={[get(show, "uuid")]}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Grid>
        </If>
      </PageWrapper>
    );
  }
}

export default PromotionsDetails;
